import { useLanguage } from '../contexts/LanguageContext';
import './Hero.css';

const Hero = () => {
  const { t, localizedPath } = useLanguage();

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-welcome">
              {t('hero.welcome')}
            </div>

            <h1 className="hero-title">
              {t('hero.title')}
              <span className="highlight">
                {t('hero.titleHighlight')}
              </span>
              {t('hero.title_1')}
            </h1>

            <p className="hero-description">
              {t('hero.description')}
            </p>

            <div className="hero-stats">
              <div className="stat-item">
                <span className="stat-label">{t('hero.statsLabel')}</span>
                <span className="stat-number">{t('hero.statsNumber')}</span>
                <span className="stat-description">{t('hero.statsDescription')}</span>
              </div>
            </div>

            <div className="hero-actions">
              <a href={localizedPath('/contact')} className="btn-primary focus-color-ring">
                {t('hero.cta')}
              </a>
              <a href={localizedPath('/services')} className="btn-secondary btn-outline focus-color-ring">
                {t('hero.learnMore')}
              </a>
            </div>

            <div className="hero-quick-links" style={{display:"none"}}>
              <span className="quick-links-label">{t('hero.quickAccess')}</span>
              <div className="quick-links">
                <a href={localizedPath('/services#ai-solutions')} className="quick-link">{t('services.aiSolutions.title')}</a>
                <a href={localizedPath('/services#cloud-migration')} className="quick-link">{t('services.cloudDeployment.title')}</a>
                <a href={localizedPath('/services#devops-automation')} className="quick-link">{t('services.devOps.title')}</a>
                <a href={localizedPath('/about')} className="quick-link">{t('nav.about')}</a>
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="rocket-container">
              <div className="rocket">
                <div className="rocket-body"></div>
                <div className="rocket-window"></div>
                <div className="rocket-fin rocket-fin-1"></div>
                <div className="rocket-fin rocket-fin-2"></div>
                <div className="rocket-flame"></div>
              </div>
              <div className="clouds">
                <div className="cloud cloud-1"></div>
                <div className="cloud cloud-2"></div>
                <div className="cloud cloud-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
